import * as React from "react"

function SvgLogoAdmin(){
    return(
        <svg width="325" height="325" viewBox="0 0 325 325" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="162.5" cy="162.5" r="162.5" fill="#4C52EA"/>
<path d="M170.964 60.9C198.897 60.9 222.044 70.862 240.405 90.786C258.962 110.515 268.24 134.736 268.24 163.45C268.24 192.164 258.962 216.483 240.405 236.407C222.044 256.136 198.897 266 170.964 266H90.975V60.9H170.964ZM170.964 240.216C191.865 240.216 208.956 232.891 222.239 218.241C235.522 203.591 242.163 185.327 242.163 163.45C242.163 141.573 235.522 123.309 222.239 108.659C208.956 94.009 191.865 86.684 170.964 86.684H118.224V240.216H170.964Z" fill="white"/>
<circle cx="170" cy="163" r="21" fill="white"/>
</svg>

    )
}
export default SvgLogoAdmin